<div class="loader" *ngIf="display"></div>
